import { render, staticRenderFns } from "./TransferIntermediate.vue?vue&type=template&id=132ba6a1&"
import script from "./TransferIntermediate.vue?vue&type=script&lang=js&"
export * from "./TransferIntermediate.vue?vue&type=script&lang=js&"
import style0 from "./TransferIntermediate.vue?vue&type=style&index=0&id=132ba6a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports